import { SUBNET_MASK_RE } from '../regexes';
import { createRegexValidator } from '../helpers';

export const validateSubnetMask = createRegexValidator(SUBNET_MASK_RE);
